import application from 'application/application';
import controller from './doc-svg.controller';

import template from './doc-svg.template.html';

application.directive('appDocSvg', [
	function() {
		return {
			restrict: 'E',
			replace: true,
			scope: {
				size: '@?'
			},
			controller: controller,
			templateUrl: template
		};
	}
]);
